import React from 'react';
import { Pagination } from 'antd';
import './CompactPagination.css';

const CompactPagination = ({ 
  current, 
  total, 
  pageSize, 
  onChange, 
  onShowSizeChange,
  showSizeChanger = true,
  showQuickJumper = false,
  showTotal = true,
  size = 'small',
  className = '',
  ...props 
}) => {
  return (
    <div className={`compact-pagination-wrapper ${className}`}>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={showQuickJumper}
        showTotal={showTotal ? (total, range) => 
          `${range[0]}-${range[1]} sur ${total}` : false
        }
        size={size}
        className="compact-pagination"
        simple={false}
        {...props}
      />
    </div>
  );
};

export default CompactPagination;
